import api from "@app/config/api/api";

export const intercomJwtOptions = api.queryOptions("get", "/auth/intercom/jwt", {
  queryKey: ["iam", "intercom-jwt"]
});
